export interface EmailMarketingScores {
  listBuilding: number;
  campaignStrategy: number;
  automationPersonalization: number;
}

export interface EmailMarketingResult {
  questionId: number;
  selectedOption: number;
  scores: EmailMarketingScores;
}

export interface Question {
  id: number;
  question: string;
  options: {
    text: string;
    scores: EmailMarketingScores;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    question: "How large and engaged is your email subscriber list?",
    options: [
      {
        text: "Large and engaged - thousands of subscribers with high open rates",
        scores: { listBuilding: 1, campaignStrategy: 1, automationPersonalization: 1 }
      },
      {
        text: "Growing steadily - hundreds of subscribers, decent engagement",
        scores: { listBuilding: 2, campaignStrategy: 1, automationPersonalization: 1 }
      },
      {
        text: "Small - under 100 subscribers or low engagement",
        scores: { listBuilding: 3, campaignStrategy: 2, automationPersonalization: 2 }
      },
      {
        text: "No list - we haven't started building an email list",
        scores: { listBuilding: 3, campaignStrategy: 3, automationPersonalization: 3 }
      }
    ]
  },
  {
    id: 2,
    question: "How do you currently grow your email subscriber list?",
    options: [
      {
        text: "Multiple strategies - lead magnets, opt-in forms, landing pages, events",
        scores: { listBuilding: 1, campaignStrategy: 1, automationPersonalization: 1 }
      },
      {
        text: "Basic opt-in - simple signup form on website",
        scores: { listBuilding: 2, campaignStrategy: 2, automationPersonalization: 1 }
      },
      {
        text: "Passive - we collect emails but no active growth strategy",
        scores: { listBuilding: 3, campaignStrategy: 2, automationPersonalization: 2 }
      },
      {
        text: "Not growing - we don't have a list building strategy",
        scores: { listBuilding: 3, campaignStrategy: 3, automationPersonalization: 3 }
      }
    ]
  },
  {
    id: 3,
    question: "How often do you send email campaigns to your Saskatchewan customers?",
    options: [
      {
        text: "Consistent schedule - weekly or bi-weekly with planned campaigns",
        scores: { listBuilding: 1, campaignStrategy: 1, automationPersonalization: 1 }
      },
      {
        text: "Monthly - we send regular updates when we have content",
        scores: { listBuilding: 1, campaignStrategy: 2, automationPersonalization: 1 }
      },
      {
        text: "Sporadic - only when we have a promotion or announcement",
        scores: { listBuilding: 2, campaignStrategy: 3, automationPersonalization: 2 }
      },
      {
        text: "Rarely or never - we don't send regular email campaigns",
        scores: { listBuilding: 2, campaignStrategy: 3, automationPersonalization: 3 }
      }
    ]
  },
  {
    id: 4,
    question: "Do you segment your email list and personalize content for different audiences?",
    options: [
      {
        text: "Advanced segmentation - multiple segments with tailored content",
        scores: { listBuilding: 1, campaignStrategy: 1, automationPersonalization: 1 }
      },
      {
        text: "Basic segmentation - a few groups with some customization",
        scores: { listBuilding: 1, campaignStrategy: 2, automationPersonalization: 2 }
      },
      {
        text: "Minimal - same message to everyone with basic personalization",
        scores: { listBuilding: 2, campaignStrategy: 3, automationPersonalization: 3 }
      },
      {
        text: "No segmentation - one-size-fits-all emails",
        scores: { listBuilding: 2, campaignStrategy: 3, automationPersonalization: 3 }
      }
    ]
  },
  {
    id: 5,
    question: "What email automation and workflows do you have in place?",
    options: [
      {
        text: "Comprehensive - welcome series, nurture campaigns, re-engagement, abandoned cart",
        scores: { listBuilding: 1, campaignStrategy: 1, automationPersonalization: 1 }
      },
      {
        text: "Basic automation - welcome email and maybe one or two sequences",
        scores: { listBuilding: 1, campaignStrategy: 2, automationPersonalization: 2 }
      },
      {
        text: "Manual only - all emails are sent manually, no automation",
        scores: { listBuilding: 2, campaignStrategy: 2, automationPersonalization: 3 }
      },
      {
        text: "None - we don't use email automation",
        scores: { listBuilding: 2, campaignStrategy: 3, automationPersonalization: 3 }
      }
    ]
  },
  {
    id: 6,
    question: "How do you measure and optimize your email marketing performance?",
    options: [
      {
        text: "Data-driven - track opens, clicks, conversions, A/B test regularly",
        scores: { listBuilding: 1, campaignStrategy: 1, automationPersonalization: 1 }
      },
      {
        text: "Basic tracking - monitor open rates and clicks occasionally",
        scores: { listBuilding: 1, campaignStrategy: 2, automationPersonalization: 2 }
      },
      {
        text: "Minimal - we check stats but don't optimize based on them",
        scores: { listBuilding: 2, campaignStrategy: 3, automationPersonalization: 2 }
      },
      {
        text: "No tracking - we don't measure email performance",
        scores: { listBuilding: 3, campaignStrategy: 3, automationPersonalization: 3 }
      }
    ]
  },
  {
    id: 7,
    question: "What results are you currently getting from email marketing?",
    options: [
      {
        text: "Strong ROI - high engagement, leads, and sales from email",
        scores: { listBuilding: 1, campaignStrategy: 1, automationPersonalization: 1 }
      },
      {
        text: "Moderate results - some engagement but could be better",
        scores: { listBuilding: 2, campaignStrategy: 2, automationPersonalization: 2 }
      },
      {
        text: "Poor results - low open rates, few clicks or conversions",
        scores: { listBuilding: 3, campaignStrategy: 3, automationPersonalization: 3 }
      },
      {
        text: "Unknown - we don't track results or don't send emails",
        scores: { listBuilding: 3, campaignStrategy: 3, automationPersonalization: 3 }
      }
    ]
  }
];
